import { memo, useContext, useCallback, useEffect } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";

const Category = memo(() => {
	const { inputs, setInputs, errors, setErrors } = useContext(Data);

	const categorySelect = useCallback((e) => {
		if (e.target.value === "その他") {
			setInputs(() => ({
				...inputs,
				category: e.target.value,
				subject: "その他",
			}));
			setErrors({ ...errors, subject: null });
		} else {
			setInputs(() => ({
				...inputs,
				category: e.target.value,
				subject: "default",
			}));
			setErrors(() => ({ ...errors, subject: "*必須" }));
		}
	});

	const catList = ["ソファを検討中", "ソファを使用中", "その他"];

	const imageNameList = {
		ソファを検討中: "customer",
		ソファを使用中: "user",
		その他: "other",
	};

	return (
		<div className={styles.category}>
			<h3 className={`en ${styles.headline}`}>
				TYPE<span>お問い合わせの種類をお選びください</span>
			</h3>
			<div>
				{catList.map((item, index) => {
					return (
						<label
							key={index}
							onChange={categorySelect}
							style={
								item === inputs.category
									? { backgroundColor: "#1c1c1c", color: "#fff" }
									: null
							}
						>
							<img
								src={`images/${imageNameList[item]}_${
									item === inputs.category ? "on" : "off"
								}.png`}
								alt=""
							/>
							<input name="category" type="radio" value={item} />
							{item}
						</label>
					);
				})}
			</div>
		</div>
	);
});

export default Category;
